import React, { useMemo } from 'react';
import { Icon } from '@polichat/flamboyant';
import { IconPlusIcon } from '../../../../../assets/illustratorElement/iconPlusIcon/iconPlusIcon';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import CombinedLogo from '../../../../../assets/images/poli-plus-whatsapp.svg';
import {
  Container,
  LogoContainer,
  StepsContainer,
  InformationalTextContainer,
  StepsItemContainer,
  StepItem,
} from './ProgressBar.styles';

// Lógica do componente que renderizará as etapas da homologação
const ProgressBar = ({
  currentStep = 0,
  title = '',
  auxiliaryButton = null,
}) => {
  const step1Name = useGlotaT('spa.certification.progressStep1');
  const step2Name = useGlotaT('spa.certification.progressStep2');
  const step3Name = useGlotaT('spa.certification.progressStep3');
  const progressTitle = useGlotaT('spa.certification.progressTitle');

  const steps = useMemo(
    () => [
      { id: 1, name: step1Name },
      { id: 2, name: step2Name },
      { id: 3, name: step3Name },
    ],
    [step1Name, step2Name, step3Name]
  );

  // Renderizar os itens dos steps
  const stepItems = steps.map(({ id, name }) => (
    <StepItem key={id} passed={id < currentStep} className={id < currentStep}>
      {id < currentStep ? (
        <Icon icon="poli-icon pi-finish-fill" size={24} />
      ) : (
        <Icon icon="poli-icon pi-finish-line" size={24} />
      )}
      <span>{name}</span>
    </StepItem>
  ));

  return (
    <Container>
      {/* <LogoContainer>
      <div
        className="mainLogo"
        style={{ width: '50px', backgroundColor: 'inherit' }}
      />

      <div style={{ marginTop: '15px' }}>
        <Icon icon="poli-icon pi-add-fill" size={25} />
      </div>

      <div style={{ marginTop: '5px' }}>
        <Icon
          icon={'poli-icon pi-whatsapp-fill'}
          color={'var(--success)'}
          size={45}
        />
      </div>
    </LogoContainer> */}
      <IconPlusIcon
        firstIcon="onlyLogo"
        secondIcon="poli-icon pi-whatsapp-api-fill"
        secondColor="var(--success)"
      />

      <StepsContainer style={{ width: '100%' }}>
        <InformationalTextContainer
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div>
            {title}
            {title === '' && currentStep === 0 && progressTitle}
          </div>
          {auxiliaryButton && <div>{auxiliaryButton}</div>}
        </InformationalTextContainer>
        {currentStep > 0 && (
          <StepsItemContainer>{stepItems}</StepsItemContainer>
        )}
      </StepsContainer>
    </Container>
  );
};

export default ProgressBar;
